import { put, call, takeLatest } from 'redux-saga/effects';
import * as dashboardServices from 'src/services/dashboard.service';
import dashboardActions from './dashboardActions';
import dashboardTypes from './dashboardTypes';

const error = errorObject => {
  return errorObject.response ? errorObject.response : errorObject;
};

export function* dashboardHeaderCountsSaga() {
  try {
    const data = yield call(dashboardServices.fetchDashboardHeaderCount);

    if (!data.success) throw error(data);

    delete data.success;

    yield put(dashboardActions.fetchDashboardHeaderCountsSuccess(data));
  } catch (err) {
    yield put(dashboardActions.fetchDashboardHeaderCountsFailure(err));
  }
}

const dashboardSaga = [takeLatest(dashboardTypes.FETCH_DASHBOARD_HEADER_COUNTS_PENDING, dashboardHeaderCountsSaga)];

export default dashboardSaga;
